import { List } from '../objects/list';
import { Errors } from '../objects/errors';
import { Margin, MarginBookingEngine } from '../objects/margin';
import { Currency } from '../../currency/objects/currency';
import { IataAirline } from '../../iata/objects/iataAirline';
import { Preferences } from '../../profile/objects/preferences';
import { NetworkMinimal } from '../../network/objects/networkMinimal';
import { Organisation } from '../../organisation/objects/organisation';
import { ProviderActivation } from '../../provider/objects/providerActivation';
import { DestinationReduced } from '../../destination/objects/destinationReduced';
import { OrganisationMinimal } from '../../organisation/objects/organisationMinimal';
import { Column } from '../objects/column';
import { ClientBranchCompany } from '../objects/company';
import { FlightSpecificLevel } from '../objects/flightSpecificLevel';

export const ADD_PREFERENCES = 'MARGIN_ADD_PREFERENCES';
export const ADD_RATE = 'MARGIN_ADD_RATE';
export const DELETE_RATE = 'MARGIN_DELETE_RATE';
export const MOVE_DOWN_COLUMN = 'MARGIN_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'MARGIN_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'MARGIN_RESET_FILTERS';
export const RESET_MARGIN = 'MARGIN_RESET_MARGIN';
export const SET_CONTENT_TYPE_ERROR = 'MANUAL_ACCOMMODATION_SET_CONTENT_TYPE_ERROR';
export const SET_ERRORS = 'MARGIN_SET_ERRORS';
export const SET_EXPORT_TYPE = 'MARGIN_SET_EXPORT_TYPE';
export const SET_LIMIT = 'MARGIN_SET_LIMIT';
export const SET_LIST = 'MARGIN_SET_LIST';
export const SET_MARGIN = 'MARGIN_SET_MARGIN';
export const SET_ORDER_BY = 'MARGIN_SET_ORDER_BY';
export const SET_PAGE = 'MARGIN_SET_PAGE';
export const SET_PREFERENCES = 'MARGIN_SET_PREFERENCES';
export const SET_RUNNING = 'MARGIN_SET_RUNNING';
export const SET_SEARCH = 'MARGIN_SET_SEARCH';
export const SET_SUSPEND = 'MARGIN_SET_SUSPEND';
export const TOGGLE_COLUMN = 'MARGIN_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'MARGIN_TOGGLE_CREATE';
export const TOGGLE_EXPORT = 'MARGIN_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'MARGIN_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'MARGIN_TOGGLE_FILTERS';
export const TOGGLE_NAME_DEPLOYED = 'MARGIN_TOGGLE_NAME_DEPLOYED';
export const TOGGLE_REFRESH = 'MARGIN_TOGGLE_REFRESH';
export const TOGGLE_SURCOM = 'MARGIN_TOGGLE_SURCOM';
export const TOGGLE_TVA_MARGIN_ONLY = 'MARGIN_TOGGLE_TVA_MARGIN_ONLY';
export const UPDATE_AGENCY = 'MARGIN_UPDATE_AGENCY';
export const UPDATE_APPLIED_UNDER = 'MARGIN_UPDATE_APPLIED_UNDER';
export const UPDATE_CONTENT_TYPE = 'MARGIN_UPDATE_CONTENT_TYPE';
export const UPDATE_CURRENCY = 'MARGIN_UPDATE_CURRENCY';
export const UPDATE_DATE_GTE = 'MARGIN_UPDATE_DATE_GTE';
export const UPDATE_DATE_LTE = 'MARGIN_UPDATE_DATE_LTE';
export const UPDATE_DESTINATIONS = 'MARGIN_UPDATE_DESTINATIONS';
export const UPDATE_FILTER_ACTIVATED = 'MARGIN_UPDATE_FILTER_ACTIVATED';
export const UPDATE_FILTER_CONTENT_TYPE = 'MARGIN_UPDATE_FILTER_CONTENT_TYPE';
export const UPDATE_FILTER_BOOKING_ENGINES = 'MARGIN_UPDATE_FILTER_BOOKING_ENGINES';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'MARGIN_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'MARGIN_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'MARGIN_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'MARGIN_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'MARGIN_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'MARGIN_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_NETWORK = 'MARGIN_UPDATE_FILTER_NETWORK';
export const UPDATE_FILTER_ORGANISATION = 'MARGIN_UPDATE_FILTER_ORGANISATION';
export const UPDATE_FILTER_PERIOD = 'MARGIN_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'MARGIN_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FLIGHT_CLASS_BOOKING = 'MARGIN_UPDATE_FLIGHT_CLASS_BOOKING';
export const UPDATE_FLIGHT_FARE_BASIS = 'MARGIN_UPDATE_FLIGHT_FARE_BASIS';
export const UPDATE_FLIGHT_IATA_AIRLINE = 'MARGIN_UPDATE_FLIGHT_IATA_AIRLINE';
export const UPDATE_FLIGHT_SPECIFICS = 'MARGIN_UPDATE_FLIGHT_SPECIFICS';
export const UPDATE_NAME = 'MARGIN_UPDATE_NAME';
export const UPDATE_NAME_LOCALE = 'MARGIN_UPDATE_NAME_LOCALE';
export const UPDATE_NETWORK = 'MARGIN_UPDATE_NETWORK';
export const UPDATE_ORGANISATION = 'MARGIN_UPDATE_ORGANISATION';
export const UPDATE_PROVIDER = 'MARGIN_UPDATE_PROVIDER';
export const UPDATE_RATE_TYPE = 'MARGIN_UPDATE_RATE_TYPE';
export const UPDATE_RATE = 'MARGIN_UPDATE_RATE';
export const UPDATE_TARGET = 'MARGIN_UPDATE_TARGET';
export const UPDATE_TYPE = 'MARGIN_UPDATE_TYPE';
export const SET_COLUMNS = 'MARGIN_SET_COLUMNS';
export const SET_COMPANY = 'MARGIN_SET_COMPANY';
export const SET_COMPANIES = 'MARGIN_SET_COMPANIES';
export const SET_NAME_LOCALES = 'MARGIN_SET_NAME_LOCALES';
export const UPDATE_BOOKING_ENGINES = 'MARGIN_UPDATE_BOOKING_ENGINES';
export const UPDATE_CMS = 'MARGIN_UPDATE_CMS';
export const UPDATE_FLIGHT_SPECIFICS_LEVEL = 'MARGIN_UPDATE_FLIGHT_SPECIFICS_LEVEL';
export const ADD_FLIGHT_SPECIFICS_LEVEL = 'MARGIN_ADD_FLIGHT_SPECIFICS_LEVEL';
export const DELETE_FLIGHT_SPECIFICS_LEVEL = 'MARGIN_DELETE_FLIGHT_SPECIFICS_LEVEL';
export const UPDATE_IS_MARKUP = 'MARGIN_UPDATE_IS_MARKUP';


interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}
interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface AddRateAction {
    type: typeof ADD_RATE
}

interface DeleteRateAction {
    type: typeof DELETE_RATE,
    payload: number
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface ResetMarginAction {
    type: typeof RESET_MARGIN
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Errors
}

interface SetContentTypeErrorAction {
    type: typeof SET_CONTENT_TYPE_ERROR,
    payload: string
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetMarginAction {
    type: typeof SET_MARGIN,
    payload: Margin
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface SetSuspendAction {
    type: typeof SET_SUSPEND,
    payload: Margin | null
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleCreateAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleNameDeployedAction {
    type: typeof TOGGLE_NAME_DEPLOYED,
    payload: boolean
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface ToggleSurcomAction {
    type: typeof TOGGLE_SURCOM
}

interface ToggleTvaMarginOnlyAction {
    type: typeof TOGGLE_TVA_MARGIN_ONLY
}

interface UpdateAgencyAction {
    type: typeof UPDATE_AGENCY,
    payload: OrganisationMinimal
}

interface UpdateAppliedUnderAction {
    type: typeof UPDATE_APPLIED_UNDER,
    payload: {
        value: string | number | null,
        index: number
    }
}

interface UpdateContentTypeAction {
    type: typeof UPDATE_CONTENT_TYPE,
    payload: number[]
}

interface UpdateCurrencyAction {
    type: typeof UPDATE_CURRENCY,
    payload: {
        value: null | Currency,
        index: number
    }
}

interface UpdateDateGteAction {
    type: typeof UPDATE_DATE_GTE,
    payload: null | Date
}

interface UpdateDateLteAction {
    type: typeof UPDATE_DATE_LTE,
    payload: null | Date
}

interface UpdateDestinationsAction {
    type: typeof UPDATE_DESTINATIONS,
    payload: DestinationReduced[]
}

interface UpdateFilterActivatedAction {
    type: typeof UPDATE_FILTER_ACTIVATED,
    payload: 'ACTIVATED' | 'DEACTIVATED' | 'BOTH'
}

interface UpdateFilterContentTypeAction {
    type: typeof UPDATE_FILTER_CONTENT_TYPE,
    payload: number[]
}
interface UpdateFilterBookingEnginesAction {
    type: typeof UPDATE_FILTER_BOOKING_ENGINES,
    payload: MarginBookingEngine[]
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterNetworkAction {
    type: typeof UPDATE_FILTER_NETWORK,
    payload: NetworkMinimal | null
}

interface UpdateFilterOrganisationAction {
    type: typeof UPDATE_FILTER_ORGANISATION,
    payload: Organisation | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFlightClassBookingAction {
    type: typeof UPDATE_FLIGHT_CLASS_BOOKING,
    payload: string
}

interface UpdateFlightFareBasisAction {
    type: typeof UPDATE_FLIGHT_FARE_BASIS,
    payload: string
}

interface UpdateFlightIataAirlineAction {
    type: typeof UPDATE_FLIGHT_IATA_AIRLINE,
    payload: null | IataAirline
}

interface UpdateFlightSpecificsAction {
    type: typeof UPDATE_FLIGHT_SPECIFICS,
    payload: 0 | 1 | 2 | 3 | 4 | 5 | 6
}

interface UpdateNameAction {
    type: typeof UPDATE_NAME,
    payload: string
}

interface UpdateNameLocaleAction {
    type: typeof UPDATE_NAME_LOCALE,
    payload: {
        id: number,
        value: string
    }
}

interface UpdateNetworkAction {
    type: typeof UPDATE_NETWORK,
    payload: null | NetworkMinimal
}

interface UpdateOrganisationAction {
    type: typeof UPDATE_ORGANISATION,
    payload: null | Organisation
}

interface UpdateProviderAction {
    type: typeof UPDATE_PROVIDER,
    payload: null | ProviderActivation
}

interface UpdateRateAction {
    type: typeof UPDATE_RATE,
    payload: {
        value: number,
        index: number
    }
}

interface UpdateRateTypeAction {
    type: typeof UPDATE_RATE_TYPE,
    payload: {
        value: 'FIX' | 'PER',
        index: number
    }
}

interface UpdateTargetAction {
    type: typeof UPDATE_TARGET,
    payload: 0 | 1 | 2
}

interface UpdateTypeAction {
    type: typeof UPDATE_TYPE,
    payload: 0 | 1 | 2 | 3 | 4
}

interface SetCompanyAction {
    type: typeof SET_COMPANY,
    payload: ClientBranchCompany | null
}
interface SetCompaniesAction {
    type: typeof SET_COMPANIES,
    payload: (ClientBranchCompany)[]
}
interface SetNameLocalesAction {
    type: typeof SET_NAME_LOCALES,
    payload: any
}
interface UpdateBookingEnginesAction {
    type: typeof UPDATE_BOOKING_ENGINES,
    payload: MarginBookingEngine[]
}
interface UpdateCmsAction {
    type: typeof UPDATE_CMS,
    payload: ("B2B" | "B2C")[]
}
interface UpdateFlightSpecificsLevelAction {
    type: typeof UPDATE_FLIGHT_SPECIFICS_LEVEL,
    payload: {index: number, value: FlightSpecificLevel}
}
interface AddFlightSpecificsLevelAction {
    type: typeof ADD_FLIGHT_SPECIFICS_LEVEL,
}
interface DeleteFlightSpecificsLevelAction {
    type: typeof DELETE_FLIGHT_SPECIFICS_LEVEL,
    payload: number
}
interface UpdateIsMarkupAction {
    type: typeof UPDATE_IS_MARKUP,
    payload: boolean
}

export type MarginActionTypes =
    SetColumnsAction |
    AddPreferencesAction |
    AddRateAction |
    DeleteRateAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    ResetMarginAction |
    SetErrorsAction |
    SetContentTypeErrorAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetMarginAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    SetSuspendAction |
    ToggleColumnAction |
    ToggleCreateAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleNameDeployedAction |
    ToggleRefreshAction |
    ToggleSurcomAction |
    ToggleTvaMarginOnlyAction |
    UpdateAgencyAction |
    UpdateAppliedUnderAction |
    UpdateContentTypeAction |
    UpdateCurrencyAction |
    UpdateDateGteAction |
    UpdateDateLteAction |
    UpdateDestinationsAction |
    UpdateFilterActivatedAction |
    UpdateFilterContentTypeAction |
    UpdateFilterBookingEnginesAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterNetworkAction |
    UpdateFilterOrganisationAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFlightClassBookingAction |
    UpdateFlightFareBasisAction |
    UpdateFlightIataAirlineAction |
    UpdateFlightSpecificsAction |
    UpdateNameAction |
    UpdateNameLocaleAction |
    UpdateNetworkAction |
    UpdateOrganisationAction |
    UpdateProviderAction |
    UpdateRateAction |
    UpdateRateTypeAction |
    UpdateTargetAction |
    UpdateTypeAction |
    SetCompanyAction |
    SetCompaniesAction |
    SetNameLocalesAction |
    UpdateCmsAction |
    UpdateFlightSpecificsLevelAction |
    AddFlightSpecificsLevelAction |
    DeleteFlightSpecificsLevelAction |
    UpdateIsMarkupAction |
    UpdateBookingEnginesAction;